// @flow
import React from "react";
import { Form } from "react-bootstrap";
import * as layoutConstants from "../../data/layout";

/**
 * Componente para el tipo de barra lateral izquierda
 *
 * @param {Object} props - Propiedades del componente
 * @param {Function} props.changeLeftSiderbarType - Función para cambiar el tipo de barra lateral izquierda
 * @param {String} props.leftSideBarType - Tipo de barra lateral izquierda
 * @param {Object} props.layoutConstants - Constantes de barra lateral izquierda
 * @returns {JSX.Element} Componente de React
 */
const LeftSideBarType = ({
  changeLeftSiderbarType,
  leftSideBarType,
  layoutConstants,
}) => {
  return (
    <>
      {/* <Form.Check className="form-check form-switch mb-1 mt-3">
        <Form.Check.Input
          type="radio"
          name="leftsidebar-size"
          id="default-check"
          value={layoutConstants.LEFT_SIDEBAR_TYPE_FIXED}
          onChange={(e) => changeLeftSiderbarType(e.target.value)}
          checked={leftSideBarType === layoutConstants.LEFT_SIDEBAR_TYPE_FIXED}
        />
        <Form.Check.Label htmlFor="default-check">Estático</Form.Check.Label>
      </Form.Check> */}

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          name="leftsidebar-size"
          id="condensed-check"
          value={layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED}
          onChange={(e) => changeLeftSiderbarType(e.target.value)}
          checked={
            leftSideBarType === layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED
          }
        />
        <Form.Check.Label htmlFor="condensed-check">Reducido</Form.Check.Label>
      </Form.Check>

      {/* <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          name="leftsidebar-size"
          id="compact-check"
          value={layoutConstants.LEFT_SIDEBAR_TYPE_SCROLLABLE}
          onChange={(e) => changeLeftSiderbarType(e.target.value)}
          checked={
            leftSideBarType === layoutConstants.LEFT_SIDEBAR_TYPE_SCROLLABLE
          }
        />
        <Form.Check.Label htmlFor="compact-check">Desplazable</Form.Check.Label>
      </Form.Check> */}
    </>
  );
};

export default LeftSideBarType;
